/** ***********************************************************************
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

import React, { Component } from 'react';
import './pageLoader.scss';

class PageLoader extends Component {
    renderSmallCardSection() {
        return (
            <div className="small-card-section">
                <div className="header loader-animator" />
                <div className="card-wrapper">
                    <div className="card loader-animator" />
                    <div className="card loader-animator" />
                </div>
            </div>
        );
    }

    renderLargeCradSection() {
        return (
            <div className="large-card-section">
                <div className="header loader-animator" />
                <div className="card loader-animator" />
            </div>
        );
    }

    render() {
        return (
            <div className="loader">
                {this.renderSmallCardSection()}
                {this.renderLargeCradSection()}
                {this.renderLargeCradSection()}
                {this.renderLargeCradSection()}
            </div>
        );
    }
}

export default PageLoader;
